import PropTypes from 'prop-types';
import React from 'react';

// Warning icon for soft block (EV_REGULATION_ERROR_CODE.SOFT_BLOCK)
export const WarningTriangleIcon = ({ className }) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.9492 13.2114C10.9492 13.7637 10.5015 14.2114 9.94923 14.2114C9.39693 14.2114 8.94923 13.7637 8.94923 13.2114C8.94923 12.6591 9.39693 12.2114 9.94923 12.2114C10.5015 12.2114 10.9492 12.6591 10.9492 13.2114Z"
      fill="#136FD8"
    />
    <path
      d="M10.9492 6.21142C10.9492 5.65914 10.5015 5.21142 9.94923 5.21142C9.39693 5.21142 8.94923 5.65914 8.94923 6.21142V10.2114C8.94923 10.7637 9.39693 11.2114 9.94923 11.2114C10.5015 11.2114 10.9492 10.7637 10.9492 10.2114V6.21142Z"
      fill="#136FD8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66062 1.89606C8.12424 -0.632015 11.7742 -0.632025 13.2378 1.89605L19.3814 12.5076C20.848 15.041 19.02 18.2116 16.0927 18.2116H3.80569C0.878425 18.2116 -0.949605 15.041 0.517065 12.5076L6.66062 1.89606ZM11.507 2.89813C10.8137 1.70062 9.08473 1.70062 8.39143 2.89813L2.24792 13.5097C1.55318 14.7097 2.41909 16.2116 3.80569 16.2116H16.0927C17.4793 16.2116 18.3453 14.7097 17.6505 13.5097L11.507 2.89813Z"
      fill="#136FD8"
    />
  </svg>
);

WarningTriangleIcon.propTypes = {
  className: PropTypes.string,
};

WarningTriangleIcon.defaultProps = {
  className: '',
};

// Error icon for hard block (EV_REGULATION_ERROR_CODE.HARD_BLOCK)
export const ErrorCircleIcon = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11 6C11 6.55228 10.5523 7 10 7C9.4477 7 9 6.55228 9 6C9 5.44772 9.4477 5 10 5C10.5523 5 11 5.44772 11 6Z"
      fill="#D42E1C"
    />
    <path
      d="M10 8C10.5523 8 11 8.4477 11 9V14C11 14.5523 10.5523 15 10 15C9.4477 15 9 14.5523 9 14V9C9 8.4477 9.4477 8 10 8Z"
      fill="#D42E1C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z"
      fill="#D42E1C"
    />
  </svg>
);

ErrorCircleIcon.propTypes = {
  className: PropTypes.string,
};

ErrorCircleIcon.defaultProps = {
  className: '',
};
